import { Injectable } from '@angular/core';
import { URL_API } from '../global/config';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Favoritox } from '../models/Postulantex';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FavoritoApiRestService {

  private urlEndPoint: string = URL_API.UrlApi+'/api/v1/favoritos';
  private httpHeaders = new HttpHeaders({'Content-Type':'application/json'});

constructor(
  private http: HttpClient
) { }

  getFavoritos():Observable<Favoritox[]>{
    return this.http.get(this.urlEndPoint).pipe(
      map( (response) => response as Favoritox[])
    )
  }

  crearFavorito(favorito: Favoritox): Observable<Favoritox>{
    return this.http.post<Favoritox>(this.urlEndPoint, favorito, { headers: this.httpHeaders});
  }

  eliminarFavoritoPorPostulanteId(postulante_id: Number): Observable<Favoritox>{
    return this.http.delete<Favoritox>(`${this.urlEndPoint}/${postulante_id}/postulante`, {headers: this.httpHeaders});
  }


}
